import { images, brandCards, links, TID } from "@/data";
import { Link } from "react-router-dom";

const Brands = () => {
  return (
    <section className="brands section" id="brands">
      <div className="container">
        <div className="brands__grid">
          <div className="brands__intro">
            <h2 className="brands__title">Built for Every Kind of Traveler.</h2>
            <p className="brands__text">
              We bring three decades of travel expertise across B2B, B2C, and corporate segments, powered by deep local insight and global execution.
            </p>
            <Link to="/brands" className="btn btn--solid" data-testid={TID.brandsDiscover}>
              <span className="btn__dot" />Discover our brands
            </Link>
          </div>

          <div className="brands__cards">
            {brandCards.map((b) => (
              <a className="brand-card" key={b.name} href={b.href} target="_blank" rel="noopener noreferrer">
                <img className="brand-card__img" src={b.image} alt={b.name} loading="lazy" />
                <span className="brand-card__plus" aria-hidden="true">
                  <img src={images.plusIcon} alt="" />
                </span>
                <div className="brand-card__overlay">
                  <h3 className="brand-card__name">{b.name}</h3>
                  <p className="brand-card__desc">{b.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;
